import React from "react";
import RightSideDrawer from "../../../../../components/reusable/RightSideDrawer";
import DrawerSection from "../../../../../components/reusable/DrawerSection";
import DetailRow from "../../../../../components/reusable/DetailRow";
import StatusBadge from "../../../../../utils/StatusBadge";

const DepartmentDrawer = ({
    department,
    isOpen,
    onClose,
    onEdit,
    onDelete,
}) => {

    if (!department) { return null; }

    return (
        <RightSideDrawer
            isOpen={isOpen}
            onClose={onClose}
            title="Department Details"
            width="520px"
        >
            <DrawerSection title="General Information">
                <DetailRow
                    label="Department"
                    value={ department.name || "—" }
                />

                <DetailRow
                    label="Code"
                    value={ department.code || "—" }
                />

                <DetailRow
                    label="Office"
                    value={ department.office || "—" }
                />

                <DetailRow
                    label="Status"
                    value={ <StatusBadge status={ department.status } /> }
                />

                <DetailRow
                    label="Description"
                    value={ department.description || "No description" }
                />
            </DrawerSection>

            <DrawerSection title="Workload">
                <DetailRow
                    label="Employees"
                    value={ department.employees ?? 0 }
                />

                <DetailRow
                    label="Active Tasks"
                    value={ department.activeTasks ?? 0 }
                />

                <DetailRow
                    label="Completed Tasks"
                    value={ department.completedTasks ?? 0 }
                />

                <DetailRow
                    label="Task Completion"
                    value={
                        department.completionRate != null
                            ? `${department.completionRate}%`
                            : "—"
                    }
                />
            </DrawerSection>

            <DrawerSection title="Department Head">
                <DetailRow
                    label="Department Head"
                    value="Not configured"
                />

                <div
                    style={{
                        marginTop: "8px",
                        color: "#64748b",
                        fontSize: "13px",
                        lineHeight: 1.5,
                    }}
                >
                    The current Department model does not
                    contain a department-head field.
                </div>
            </DrawerSection>

            <div
                style={{
                    display: "flex",
                    gap: "10px",
                    marginTop: "24px",
                }}
            >
                <button
                    type="button"
                    onClick={() => onEdit?.(department) }
                    style={{
                        flex: 1,
                        padding: "11px 16px",
                        borderRadius: "10px",
                        border: "1px solid #d1d5db",
                        background: "#fff",
                        cursor: "pointer",
                        fontWeight: 600,
                    }}
                >
                    Edit
                </button>


                <button
                    type="button"
                    onClick={() => onDelete?.(department) }
                    style={{
                        flex: 1,
                        padding: "11px 16px",
                        borderRadius: "10px",
                        border: "1px solid #fecaca",
                        background: "#fff",
                        color: "#dc2626",
                        cursor: "pointer",
                        fontWeight: 600,
                    }}
                >
                    Deactivate
                </button>
            </div>
        </RightSideDrawer>
    );
};

export default DepartmentDrawer;
